import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const QUERY = gql`
  query LongFormSectionsForContentType($contentType: LongFormContentTypeEnum!) {
    longFormSectionsForContentType(contentType: $contentType) {
      assetType
    }
  }
`;

export const queryLongFormSectionsForContentType = async (contentType, options = null) => {
  const variables = {
    contentType,
  };

  const response = await executeGqlQuery({
    query: QUERY,
    variables,
    options: {
      abortSignal: options?.abortSignal,
    },
  });
  return getSingleProp(response.data);
};
